import { render, staticRenderFns } from "./writeoff-setup.vue?vue&type=template&id=edea34bc&scoped=true&"
import script from "./writeoff-setup.vue?vue&type=script&lang=js&"
export * from "./writeoff-setup.vue?vue&type=script&lang=js&"
import style0 from "./writeoff-setup.vue?vue&type=style&index=0&id=edea34bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edea34bc",
  null
  
)

export default component.exports